<template>
  <div>
    <div class="code-container_pc" v-if="show" @click="hidePupop">
      <div
        class="contentBox"
        :class="[show ? 'fade-in' : 'fade-out']"
        @click.stop=""
        :style="{ top: `${top}rem`, left: `${left}rem` }"
      >
        <div class="topPart">
          <img
            src="../../public/imgs/code/miniPro_judai_make.png"
            class="codeImg"
          />
        </div>
        <div class="bottomPart">扫码进入微信小程序</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    left: {
      default: 0,
    },
    top: {
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      scrollPosition: 0,

      codeType: 0,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    showPupop() {
      this.show = true;
    },
    hidePupop() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 淡出动画 */
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* 大于768的样式 */
@media screen and (min-width: 1440px) {
  .code-container_m {
    display: none;
  }
  .code-container_pc {
    height: calc(100% - 1.85rem);
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    left: 0;
    top:  1.85rem;
    z-index: 99999999;
    // width: 5.98rem;
    // height: 7.54rem;
    .contentBox {
      width: 5.98rem;
      height: 7.54rem;
      position: absolute;
      opacity: 0;
      .topPart {
        padding: 0.6rem 0.78rem;
        width: 100%;
        // height: 8.07rem;
        background: #ffffff;
        border-radius: 0.15rem 0.15rem 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .codeImg {
          width: 100%;
        }
      }
      .bottomPart {
        width: 100%;
        height: 1.89rem;
        background: #c25e4d;
        border-radius: 0rem 0rem 0.15rem 0.15rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: HarmonyOS_Sans_SC_Medium;
        font-size: 0.44rem;
        color: #ffffff;
        line-height: 0.63rem;
        text-align: right;
        font-style: normal;
      }
    }
    .fade-in {
      animation: fadeIn 0.1s ease-in forwards;
    }

    .fade-out {
      animation: fadeOut 0.1s ease-out forwards;
    }
  }
}
/* 小于等于768px的情况 */
@media screen and (max-width: 1439px) {
  .code-container_m {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .contentBox {
      width: 5.98rem;
      height: 7.54rem;
      opacity: 0;
      .topPart {
        padding: 0.6rem 0.78rem;
        width: 100%;
        // height: 8.07rem;
        background: #ffffff;
        border-radius: 0.15rem 0.15rem 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .codeImg {
          width: 100%;
        }
      }
      .bottomPart {
        width: 100%;
        height: 1.89rem;
        background: #c25e4d;
        border-radius: 0rem 0rem 0.15rem 0.15rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: HarmonyOS_Sans_SC_Medium;
        font-size: 0.44rem;
        color: #ffffff;
        line-height: 0.63rem;
        text-align: right;
        font-style: normal;
      }
    }
    .fade-in {
      animation: fadeIn 0.1s ease-in forwards;
    }

    .fade-out {
      animation: fadeOut 0.1s ease-out forwards;
    }
  }
  .code-container_pc {
    display: none;
  }
}
</style>